import { useState, useCallback, useMemo } from "react"
import { filterSelectedExperiences } from "../utils/resourceHelpers"

/**
 * Hook to manage crew member selection and role filtering
 * @param {Array} crewMemberData - All available crew members
 * @returns {Object} Crew member state and handlers
 */
export const useCrewMemberManagement = (crewMemberData = []) => {
  const [selectedCrewMembers, setSelectedCrewMembers] = useState([])
  const [selectedRoles, setSelectedRoles] = useState([])
  const [isAddStaffModalVisible, setIsAddStaffModalVisible] = useState(false)
  const [editingCrewMember, setEditingCrewMember] = useState(null)

  // Filter selected crew member data
  const selectedCrewMembersData = useMemo(
    () => filterSelectedExperiences(crewMemberData, selectedCrewMembers),
    [crewMemberData, selectedCrewMembers]
  )

  // Handle crew member edit
  const handleEditCrewMember = useCallback((record) => {
    setEditingCrewMember({
      ...record,
      loaded: true,
      version: Date.now()
    })
    setIsAddStaffModalVisible(true)
  }, [])

  // Handle crew member removal
  const handleRemoveCrewMember = useCallback((id) => {
    setSelectedCrewMembers((prev) => prev.filter((memberId) => memberId !== String(id)))
  }, [])

  // Handle modal open
  const handleOpenStaffModal = useCallback(() => {
    setIsAddStaffModalVisible(true)
  }, [])

  // Handle modal close
  const handleCloseStaffModal = useCallback(() => {
    setIsAddStaffModalVisible(false)
    setEditingCrewMember(null)
  }, [])

  return {
    selectedCrewMembers,
    setSelectedCrewMembers,
    selectedCrewMembersData,
    selectedRoles,
    setSelectedRoles,
    isAddStaffModalVisible,
    editingCrewMember,
    handleEditCrewMember,
    handleRemoveCrewMember,
    handleOpenStaffModal,
    handleCloseStaffModal
  }
}
